import { render, staticRenderFns } from "./DetailChartPanel.vue?vue&type=template&id=0bddb81a&scoped=true&"
import script from "./DetailChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailChartPanel.vue?vue&type=style&index=0&id=0bddb81a&lang=scss&scoped=true&"
import style1 from "./DetailChartPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bddb81a",
  null
  
)

export default component.exports